import React, { Component } from 'react';
import { withRouter, Redirect } from 'react-router-dom';
import { onSnapshot } from 'firebase/firestore';
import Spinner from '../Spinner';
import { withFirebase } from '../Firebase';
import * as ROUTES from '../../constants/routes';
import { getToday } from '../../utils.js';


const PrayerBase = (props) => {
	return (
		<div className={`prayer ${props.level}`}>
			<div className="wrapper">
				<div className="header--prayer">
					<h2>{props.title}</h2>
					<h3>{props.displayDate}</h3>
				</div>
				<div className="body--prayer" dangerouslySetInnerHTML={{ __html: props.prayer }} />

				{ props.tryThis && props.tryThis !== '<p><br></p>' ? 
					<div className="tryThis">
						<h4>{ props.altHeading ? props.altHeading : 'Try This' }</h4>
						<div dangerouslySetInnerHTML={{ __html: props.tryThis }} />
					</div> 
					: 
					''
				}
			</div>
		</div>
	);
};

const today = getToday();

class Prayer extends Component {
	constructor(props) {
		super(props);
		
		this.state = {
			loading: false,
			prayer: {},
			prayerId: today,
			level: this.props.level,
			title: this.props.title
		};
	}
		
	componentDidMount() {
		this.setState({ 
			loading: true
		});

		this.fetchData(this.state.prayerId, this.state.level);
		localStorage.setItem('ageLevel', JSON.stringify(this.state.level));
	}

	componentWillUnmount() {
		this.unsubscribe();
	}

	fetchData(id, level) {
		this.unsubscribe = onSnapshot(this.props.firebase.prayer(id), (doc) => {
			if (!doc.data()) {
				this.props.history.replace(ROUTES.NOT_FOUND);
				return;
			}

			const data = doc.data();
			const levelData = data[level];
			const displayDate = data.displayDate;
			
			this.setState({
				loading: false,
				prayer: levelData.prayer,
				tryThis: levelData.tryThis,
				altHeading: levelData.altHeading,
				displayDate: displayDate
			});
		}, (error) => {
			console.error(error);
			this.props.history.push(ROUTES.ERROR, { error: error });
		});
	}

	render() {
		const {
			loading,
			prayerId,
			prayer,
			tryThis,
			displayDate,
			title,
			altHeading,
			level
		} = this.state;

		if (loading) {
			return (
				<section>
					<div className="wrapper">
						<Spinner />
					</div>
				</section>
			);
		}

		if (prayerId) {
			return (
				<section>
					<PrayerBase key={prayerId} id={prayerId} title={title} level={level} displayDate={displayDate} prayer={prayer} tryThis={tryThis} altHeading={altHeading} />
				</section>
			);
		} else {
			return <Redirect to={ROUTES.NOT_FOUND} />
		}
	}
}

export default withRouter(withFirebase(Prayer));